// This function should be used when you are receiving a ValidationError from
// the backend and you want to display the error message to the user.
function parseForValidationError(string: string): string | undefined {
  return (string.match(/"message":"(.*?)"/) ?? [])[1]
}

export default parseForValidationError
